import React, { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import calender from '../../assets/images/calender.svg';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import toast from 'react-hot-toast';
import 'react-phone-input-2/lib/style.css';
import chevRight from '../../assets/images/chev-right.svg';
import Button from '../../components/ui/Button';
import CustomRadioWithTooltip from '../../components/ui/CustomRadioWithTooltip';
import UpgradeToast from '../../components/layouts/UpgradeToast';
import { ApiConstants } from '../../constants/ApiConstants';
import { Routes } from '../../constants/RouteConstants';
import authContext from '../../context/authContext';
import useMakeRequest from '../../utils/ApiHelper';
import { checkPermission, setDateHelper, getBudgetPeriodDates } from '../../utils/Helper';
import { divisionOptions } from '../contributions/Contributions';
import ContributionsDetails from '../contributions/ContributionsDetails';
import SelectMonthAndYearModal from '../contributions/SelectMonthAndYearModal';
import OpportunityReportSheet from './OpportunityReportSheet';



interface contributionsInputs {
    start_date: string;
    end_date: string,
    check: any
};

interface dataTypes {
    rows?: object[],
    total_chores_hours: string | number,
    total_chores_price: string | number,
    total_expenses_price: string | number,
    total_hours_of_employment: string | number,
    total_hours_of_labour: string | number,
    total_unpaid_expenses: string | number,
}
const ContributionReport = () => {
    const navigate = useNavigate();
    const contributions = useMakeRequest();
    const checkContribution = useMakeRequest();

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const [data, setData] = useState<dataTypes | null>();
    const [selectedMonth, setSelectedMonth] = useState('')
    const [contributionForm, setContributionForm] = useState<contributionsInputs>({
        start_date: '',
        end_date: '',
        check: {},
    });

    const [isFinalized, setIsFinalized] = useState(false);
    console.log("isFinalized; ", isFinalized)

    const [employmentCap, setEmploymentCap] = useState("744");


    const [selectedDivisionType, setSelectedDivisionType] = useState<
        string | "income_based_split" | "equal_split" | "custom_split" | "time_adjust_split" | "hybrid_adjusted_split"
    >("equal_split");

    useEffect(() => {
        checkContributionFn();
    }, []); // only run once at mount

    const checkContributionFn = () => {
        if (!contributionForm?.start_date && !contributionForm?.end_date) {
            // Calculate current month’s start date based on billingDate
            const { startDate, endDate } = getBudgetPeriodDates(
                moment().year(),
                moment().month(),
                profile?.data?.hh_member?.household?.billing_date || 1
            );

            // ✅ set state so UI shows dates
            setContributionForm({
                start_date: startDate,
                end_date: endDate,
                check: {},
            });

            // ✅ also set current month name
            setSelectedMonth(moment().format("MMMM"));

            checkContribution.makeRequest({
                url: ApiConstants?.ContributionsCheck,
                payload: {
                    month: moment().month(),
                    year: moment().year(),
                    other_params: {
                        start_date: startDate,
                        end_date: endDate,
                        month: moment().month() + 1,
                        selected_month: moment().format("MMMM"),
                    },
                },
            });
        }
    }

    useEffect(() => {
        if (checkContribution?.status) {
            setContributionForm({
                start_date: checkContribution?.data?.data?.other_params?.start_date,
                end_date: checkContribution?.data?.data?.other_params?.end_date,
                check: {
                    finalized_type: checkContribution?.data?.data?.finalized_type,
                    is_finalized: checkContribution?.data?.data?.is_finalized,
                    can_finalize: checkContribution?.data?.data?.can_finalize
                }
            })
            setIsFinalized(checkContribution?.data?.data?.is_finalized == 1 ? true : false);
            setSelectedDivisionType(checkContribution?.data?.data?.finalized_type || "equal_split");
        }
    }, [checkContribution?.status])


    const onSubmit = (split: any = null) => {
        const payload: any = {
            ...contributionForm,
            type: selectedDivisionType,
        }

        if (selectedDivisionType === "custom_split") {
            payload.split_members = split;
        }
        if (selectedDivisionType === "time_adjust_split" || selectedDivisionType === "hybrid_adjusted_split") {
            payload.cap = employmentCap;
        }
        contributions.makeRequest({ payload, url: ApiConstants?.ContributionsReports }).catch((err) => {
            console.error('Error while getting contributions data------------->', err);
        })
    }

    useEffect(() => {
        if (contributions?.status) {
            const contributionsData = typeof contributions?.data?.data == 'string' ? JSON.parse(contributions?.data?.data) : contributions?.data?.data
            console.log("contributionsData", contributionsData)
            setData({
                rows: contributionsData.data,
                total_chores_hours: contributionsData.total_chores_hours,
                total_chores_price: contributionsData.total_chores_price,
                total_expenses_price: contributionsData.total_expenses_price,
                total_hours_of_employment: contributionsData.total_hours_of_employment,
                total_hours_of_labour: contributionsData.total_hours_of_labour,
                total_unpaid_expenses: contributionsData.total_unpaid_expenses,
            })
            setIsFinalized(contributionsData.is_finalized == 1 ? true : false);
            setSelectedDivisionType(contributionsData.finalized_type);
        } else {
            setData(null)
        }
        if (contributions?.error) {
            toast.error(contributions?.error?.message)
        }
    }, [contributions?.status, contributions?.error])

    useEffect(() => {
        return () => {
            $('.modal-backdrop').remove();
        }
    }, [])

    const handleViewOppertunityCost = () => {
        navigate(Routes?.OpportunityCost)
    }

    return (
        <>
            <div className="contributions-page">
                <div className=''>
                    <div className='page-padding-x pt-4'>
                        <div className='col-12'>
                            <div className="com-input-grp">
                                {/* <label className="form-label">Select Month</label> */}
                                <button type='button' data-bs-toggle="modal" data-bs-target="#selectDateModal" className=' mb-2 date-modal-btn'>
                                    {selectedMonth}
                                    <img
                                        className="up-down-arw"
                                        src={chevRight}
                                        alt=""
                                    />
                                </button>
                            </div>
                        </div>
                        <div className='row mb-4 mt-3'>
                            <div className='col-6'>
                                <div className="com-input-grp disabled-input-grp">
                                    <label className="form-label">Start Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        disabled
                                        selected={contributionForm?.start_date as any}
                                        // selected={watch("start_date") ? moment(watch("start_date")).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calender} alt="" /></>}
                                    />
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className="com-input-grp disabled-input-grp">
                                    <label className="form-label">End Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        disabled
                                        selected={contributionForm?.end_date as any}
                                        // selected={watch("end_date") ? moment(watch("end_date")).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calender} alt="" /></>}
                                    />
                                </div>
                            </div>
                        </div>

                        <Button
                            onClick={() => {
                                navigate(Routes?.ReportContribution)
                            }}
                            className="com-btn me-auto mb-3"
                            style={{ width: "100%", textDecorationLine: 'underline' }}
                        >
                            View Opportunity-cost Pricing
                        </Button>
                        <div className="mb-4 mt-4 com-input-grp">
                            <label className="form-label-large mb-3">
                                Division of Contributions
                            </label>
                            {divisionOptions.map((divisionType) => {
                                const userPerms = profile?.data?.plan_perms || profile?.plan_perms;
                                const hasAccess =
                                    !divisionType.requiredPermission ||
                                    checkPermission(userPerms, divisionType.requiredPermission);

                                return (
                                    <React.Fragment key={divisionType?.type}>
                                        <div className="form-check com-check mb-3">
                                            <CustomRadioWithTooltip
                                                id={divisionType?.type}
                                                name="divisionRadio"
                                                value={divisionType?.type}
                                                label={divisionType?.title}
                                                tooltipText={
                                                    !hasAccess
                                                        ? "Please upgrade your plan to use this feature."
                                                        : divisionType?.tooltipText
                                                }
                                                disabled={contributions?.loading || isFinalized}
                                                checked={divisionType?.type === selectedDivisionType}
                                                onChange={() => {
                                                    if (!hasAccess) {
                                                        toast.dismiss();
                                                        toast.custom((t) => <UpgradeToast t={t} />, {
                                                            id: "upgrade-toast",
                                                            duration: 3000,
                                                        });
                                                        return;
                                                    }
                                                    setSelectedDivisionType(divisionType?.type);
                                                    if (contributions?.error?.data?.income_missing) {
                                                        contributions.error.data.income_missing = false;
                                                    }
                                                }}
                                            />
                                        </div>
                                        {hasAccess && [divisionType?.type].includes(selectedDivisionType) && divisionType.showCapInput && (
                                            <div className="mb-3 d-flex align-items-center">
                                                <label htmlFor="employmentCap" className="form-label">
                                                    Cap on hours of employment
                                                </label>
                                                <input
                                                    type="number"
                                                    id="employmentCap"
                                                    maxLength={3}
                                                    className="form-control"
                                                    placeholder="3 digit"
                                                    value={employmentCap}
                                                    min={0}
                                                    max={744}
                                                    style={{ width: '10ch', marginLeft: '10px' }}
                                                    onChange={(e) => {
                                                        const val = Number(e.target.value);
                                                        if (val <= 744) {
                                                            setEmploymentCap(e.target.value);
                                                        } else {
                                                            toast.error("Cap cannot be more than 744 hours");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>

                        <div className='page-padding-x py-4'>
                            <Button
                                className="com-btn"
                                style={{ width: "100%" }}
                                onClick={() => onSubmit()}
                                loading={contributions?.loading}
                            >
                                View
                            </Button>
                        </div>

                    </div>

                    <ContributionsDetails
                        data={data as any}
                        loading={contributions?.loading}
                        fromReport={true}
                    />
                </div>
            </div>
            {/* <ShowContributionReport /> */}
            <SelectMonthAndYearModal
                billingDate={profile?.data?.hh_member?.household?.billing_date}
                onContinue={(e: any) => {
                    console.log("e :: ", e)
                    setContributionForm(e);
                    contributions.reset();
                    setIsFinalized(e.check.is_finalized == 1 ? true : false);
                    setSelectedDivisionType(e.check.finalized_type || "equal_split");
                }}
                selectMonth={setSelectedMonth}
            />

            <OpportunityReportSheet />
        </>
    )
}


export default ContributionReport